import { render, staticRenderFns } from "./PowerConsumption.vue?vue&type=template&id=35128cf4&"
import script from "./PowerConsumption.vue?vue&type=script&lang=js&"
export * from "./PowerConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports